import { render } from "./SectionPopupByRoute.vue?vue&type=template&id=23d95aef"
import script from "./SectionPopupByRoute.vue?vue&type=script&lang=js"
export * from "./SectionPopupByRoute.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__